import React, { useRef, useEffect } from 'react';
import './HorizontalScrollCards.css';

const HorizontalScrollCards = () => {
  const containerRef = useRef(null);

  const cards = [
    {
      id: 1,
      image: '/images/HEATMAP.png',
      company: 'Heatmap',
      location: 'Live Market',
      description: 'A clear map of winners and losers, instantly visualize market trends.',
      stats: ['Real-time Data', 'Sector Analysis']
    },
    {
      id: 2,
      image: 'https://images.unsplash.com/photo-1518556608552-32a51f98bc10?q=80&w=1500&auto=format&fit=crop',
      company: 'Gotham Wonder',
      location: 'Manila.',
      badge: 'FRESH',
      description: 'Boosted customer engagement with a digital presence and targeted campaigns.',
      stats: ['60% Increased Traffic', '35% Growth in Sales']
    },
    {
      id: 3,
      image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?q=80&w=1500&auto=format&fit=crop',
      company: 'Sling Interactive Tech',
      location: 'oslo.',
      description: 'Expanded market reach, tapping into new demographics with a driven approach.',
      stats: ['20% Market Share', '45% Boost in Retention']
    },
    {
      id: 4,
      image: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?q=80&w=1500&auto=format&fit=crop',
      company: 'Nexus Dynamics',
      location: 'Tokyo',
      description: 'Accelerated product delivery cycles using advanced AI modeling.',
      stats: ['40% Faster Delivery', '15% Cost Savings']
    },
    {
      id: 5,
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1500&auto=format&fit=crop',
      company: 'Quantum Systems',
      location: 'Berlin',
      badge: 'NEW',
      description: 'Streamlined data pipelines for seamless insights and analytics integration.',
      stats: ['50% Faster Queries', '2x Scalability']
    }
  ];

  return (
    <div className="horizontal-scroll-section">
      <div className="scroll-container-wrapper" ref={containerRef}>
        <div className="scroll-track">
          {[...cards, ...cards].map((card, index) => (
            <div key={`${card.id}-${index}`} className="scroll-card">
              <div className="card-image-wrapper">
                <img src={card.image} alt={card.company} className="card-image" />
                <div className="image-overlay"></div>
              </div>
              <div className="card-content">
                <div className="card-location">
                  {card.location}
                </div>
                <h3 className="card-company">
                  {card.company}
                  {card.badge && <span className="card-badge">{card.badge}</span>}
                </h3>
                <p className="card-description">{card.description}</p>
                <div className="card-stats">
                  {card.stats.map((stat, index) => (
                    <span key={index} className="stat-pill">{stat}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HorizontalScrollCards;
